import CustomDatePicker from "./CustomDatePicker";

export const widgets = {
  DateWidget: CustomDatePicker
};
